/**
 * Quick action buttons for navigating to key sections.
 * Grid of three cards: Properties, Team, Settings.
 */

import { useTranslation } from 'react-i18next';
import { Home, Users, Settings } from 'lucide-react';

interface QuickActionsProps {
  onViewProperties: () => void;
  onManageTeam: () => void;
  onSettings: () => void;
}

export function QuickActions({
  onViewProperties,
  onManageTeam,
  onSettings,
}: QuickActionsProps) {
  const { t } = useTranslation('dashboard');

  const actions = [
    {
      icon: Home,
      label: t('company.quickActions.properties'),
      onClick: onViewProperties,
      tipTarget: 'properties',
    },
    {
      icon: Users,
      label: t('company.quickActions.team'),
      onClick: onManageTeam,
      tipTarget: 'team',
    },
    {
      icon: Settings,
      label: t('company.quickActions.settings'),
      onClick: onSettings,
      tipTarget: 'settings',
    },
  ];

  return (
    <div>
      <h2 className="mb-3 text-lg font-semibold text-[var(--pv-color-primary)]">
        {t('company.quickActions.title')}
      </h2>
      <div className="grid grid-cols-3 gap-3">
        {actions.map((action) => {
          const Icon = action.icon;
          return (
            <button
              key={action.label}
              onClick={action.onClick}
              data-tip-target={action.tipTarget}
              className="flex flex-col items-center rounded-xl bg-gray-100 p-4 transition hover:bg-gray-200"
            >
              <Icon className="h-6 w-6 text-[#004D40]" />
              <span className="mt-2 text-sm font-medium text-gray-900">
                {action.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
